import { Observable } from 'rxjs';

export function readFileAsDataURL(file: Blob): Observable<string> {
  return new Observable((subscriber) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      subscriber.next(reader.result as string);
      subscriber.complete();
    };
  });
}
